<div class="search-wrapper">
    <div class="wrapper">
        <div class="wrapper-content">
            <div class="supersearch-filters bg-white folded">
                <app-header-search-form [address]="address" (emitter)="send($event)" (dateChange)="sendDate($event)"></app-header-search-form>
            </div>
            <app-search-car-filter [numberOfResult]="numberOfResult" [types]="types" [model]="model" (itemSearch)="sendItemSearch($event)" (buttonRest)="sendButtonReset($event)"></app-search-car-filter>
            <div fxLayout="row wrap" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="45%">
                    
                    <app-search-car-list [vehicles]="cars"></app-search-car-list>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="55%">
                    <app-map-senegal [mapHome]="false" [geometry]="geometry" [markers]="markers"></app-map-senegal>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
        <div class="container">
            <div class="row">
                <div id="loader">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="loading"></div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<ngx-spinner type="ball-clip-rotate-multiple" color="#3172ff" bdColor="rgba(51,51,51,0.8)">
    <p style="font-size: 20px; color: #ffffff; margin-top: 100px; font-weight: bold;">Chargement...</p>
</ngx-spinner>